export default {
  SET_DOCTORATE_STAT(state, data) {
    state.doctorateStat = data
  },
  SET_ORG_COUNT_BY_TYPE_AND_ORG_ADMIN(state, data) {
    state.orgCountByTypeAndOrgAdmin = data
  },
  SET_ORG_COUNT_BY_REGION_AND_TYPE(state, data) {
    state.orgCountByRegionAndType = data
  },
  COUNT_BY_APPLY_DOC_RESEARCHER_REGION(state, data) {
    state.countByApplyDocResearcherRegion = data
  },
  COUNT_BY_DIRECTION(state, data) {
    state.countByDirection = data
  },
  COUNT_BY_APPLY_DOC_RESEARCHER_REGION_ORG(state, data) {
    state.countByApplyDocResearcherRegionOrg = data
  },
  COUNT_BY_APPLY_DOC_RESEARCHER_REGION_DIRECTION(state, data) {
    state.countByApplyDocResearcherOrganizationDirection = data
  },
  APPLIED_YEAR_COUNT(state, data) {
    state.appliedYearCount = data
  },
  USER_COUNT(state, data) {
    state.userCount = data
  },
  APPLY_DOC_STATISTICS(state, data) {
    state.applyDocStatistics = data
  },
  ORGANIZATION_OF_DIRECTION(state, list) {
    state.organizationOfDirection = list
  },
  APPLIED_DOC_COUNT_BY_ORG(state, list) {
    state.appliedDocCountByOrganization = list
  },
  APPLIED_DOC_COUNT_BY_DIRECTION(state, list) {
    state.appliedDocCountByDirection = list
  },
}
